export default "__VITE_ASSET__DL7mZIME__"